<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary max-w-[400px] w-[100%] bg-white cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div class="mb-5" [attr.style]="getReadableQrTextStyle(items[0]?.styles?.text)">
      {{ items[0].value.text }}
    </div>
    <div
      class="mb-5"
      [attr.style]="getReadableQrTextStyle(items[1]?.styles?.text)"
      [innerHTML]="items[1].value.text | lineBreak"
    ></div>
    <div class="flex gap-6 items-center justify-center">
        <ngx-qrcode-styling #qrcode [config]="getProductQrSettings(items[2])"></ngx-qrcode-styling>
    </div>
  </div>
</div>
